/**
 * AuthCallback - Handles OIDC redirect after login.
 * WHY: Processes auth response and redirects to app.
 */
import { useAuth } from 'react-oidc-context';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/lib/routes';
import { LoadingInitializing } from '@/components/loadings/LoadingInitializing';
import { AuthError } from '@/components/auth/AuthError';
import { clearAuthState } from './AuthConfig';

const AuthCallback: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isLoading) return;

    if (auth.user) {
      navigate(ROUTES.HOME);
    }
  }, [auth.isLoading, auth.user, navigate]);

  if (auth.error) {
    return (
      <AuthError
        title="Login Failed"
        message="We couldn't complete the sign-in process. Please try again."
        buttonLabel="Return to Login"
        onRetry={() => { clearAuthState(); window.location.href = '/'; }}
      />
    );
  }

  return (
    <LoadingInitializing 
      message="Completing Authentication"
      subMessage="Please wait while we verify your credentials..."
    />
  );
};

export default AuthCallback;
